export class NodePageBasicPage extends DrupalBehavior {
  onContent(context) {
    function accreditationsSlider(context) {
      if (
        context.classList != undefined &&
        context.classList.contains('accreditations')
      ) {
        $(context).slick({
          dots: true,
          slidesToShow: 1,
          speed: 500,
          draggable: true,
          fade: false,
          arrows: false,
          adaptiveHeight: true,
        });
      }
    }

    accreditationsSlider(context);
  }
}

DrupalBehavior.register(
  'rush_theme.node_page',
  'basic_page',
  NodePageBasicPage
);
